const state = () => ({
	books: [],
	modalData: { // 弹窗信息
		modalType: "delDialog", 
		isShowModal: false,
		delType: 'book',
		book_id: ''
	},
	userInfo: new Object()
})

// getters
const getters = {
	
}

// actions
const actions = {
	openModalFn({ commit, state }, book_id) {
		commit('openModal')
		state.modalData.book_id = book_id
	}
}

// mutations
const mutations = {
	renderBookList(state, bookList) {
		state.books = bookList
	},
	delBookFn(state, book_id) {
		state.books = state.books.filter(item => {
			return item.id !== book_id
		})
		state.modalData.isShowModal = false;
	},
	closeModalFn(state) {
		state.modalData.isShowModal = false;
	},
	openModal(state) {
		state.modalData.isShowModal = true;
	},
	renderUserInfo(state, data) {
		state.userInfo = data
	}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}